<template>
<div class="rt-icon" @click="click">
    <svg :width="size" :height="size" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true">
        <use :xlink:href="'#' + name" :fill="color" />
    </svg>
</div>
</template>

<script>
export default {
    name: 'rtPortalIcon',
    props: {
        name: {
            type: String
        },
        size: {
            type: [Number, String],
            default: 14
        },
        color: {
            type: String,
            default: 'currentColor'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        click(event) {
            if (!this.disabled)
                this.$emit('click', event);
        }
    }
};
</script>

<style lang="less" scoped>
.rt-icon {
    display: inline-flex;
    pointer-events: auto;

    &>svg {
        pointer-events: none;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?1bd8bcc0